import images from "../constants/images";
import type { BuildObjects, ResourceObjects } from "../types/tokenValley";

export const getResourceGatheringIconBlockTypes = (
  block_type: BuildObjects,
): string | null => {
  let icon: string | null;

  switch (block_type) {
    case "build/farm":
      icon = images.lab.wheat;
      break;
    case "build/bakery":
      icon = images.lab.bread;
      break;
    case "build/mill":
      icon = images.lab.bag;
      break;
    case "build/lumber_mill":
      icon = images.lab.wood;
      break;
    case "build/iron_mine":
      icon = images.lab.iron;
      break;
    case "build/ranch":
      icon = images.lab.caw;
      break;
    case "build/milk_barn":
      icon = images.lab.milk;
      break;
    case "build/dairy_cellar":
      icon = images.lab.cheese;
      break;
    default:
      icon = null;
  }

  return icon;
};

export const getResourceGatheringIconResourcesTypes = (
  type: ResourceObjects,
): string | null => {
  let icon: string | null;

  switch (type) {
    case "resource/research_point": {
      icon = images.lab.coin;
      break;
    }
    case "resource/token":
      icon = images.lab.token;
      break;
    case "resource/iron":
      icon = images.lab.iron;
      break;
    case "resource/wood":
      icon = images.lab.wood;
      break;
    case "resource/wheat":
      icon = images.lab.wheat;
      break;
    case "resource/bread":
      icon = images.lab.bread;
      break;
    case "resource/milk":
      icon = images.lab.milk;
      break;
    case "resource/cheese":
      icon = images.lab.cheese;
      break;
    case "resource/cattle":
      icon = images.lab.caw;
      break;
    case "resource/flour":
      icon = images.lab.bag;
      break;

    default:
      icon = null;
  }

  return icon;
};
